/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { accountDataOrganizationSchema } from "./accountDataOrganizationSchema.ts";
import { batchErrorSchema } from "./batchErrorSchema.ts";
import { z } from "zod";

/**
 * @description Résultat du traitement d\'un lot d\'objets, avec succès et erreurs séparés
 */
export const batchResultSchema = z.object({
      "result": z.array(z.lazy(() => accountDataOrganizationSchema)).describe("Objets créés ou mis à jour avec succès").optional(),
  "errors": z.array(z.lazy(() => batchErrorSchema).describe("Erreur rencontrée lors du traitement d'un objet dans un lot")).describe("Organisations dont le traitement a échoué").optional()
      }).describe("Résultat du traitement d'un lot d'objets, avec succès et erreurs séparés")